import React, {FC, ReactNode, useCallback, useEffect, useRef} from "react"

interface Props {
    onNext: () => void
    onBack: () => void
    children?: ReactNode
}

export const MouseNavigation: FC<Props> = ({ onNext, onBack, children }) => {
    const threshold = 200
    const cooldownTime = 500
    const scrollDelta = useRef(0)
    const cooldown = useRef(false)

    const handleWheel = useCallback((e: WheelEvent) => {
        if (cooldown.current) return
        scrollDelta.current += e.deltaY
        if (scrollDelta.current > threshold) {
            onNext()
            scrollDelta.current = 0
            cooldown.current = true
            setTimeout(() => (cooldown.current = false), cooldownTime)
        } else if (scrollDelta.current < -threshold) {
            onBack()
            scrollDelta.current = 0
            cooldown.current = true
            setTimeout(() => (cooldown.current = false), cooldownTime)
        }
    }, [onNext, onBack])

    useEffect(() => {
        window.addEventListener("wheel", handleWheel, { passive: true })
        return () => window.removeEventListener("wheel", handleWheel)
    }, [handleWheel])

    return <>{children}</>
}